/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct inaccurate data`)
};

const es_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corregir datos inexactos`)
};

const de_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichtigung ungenauer Daten`)
};

const nl_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onjuiste gegevens te corrigeren`)
};

const fr_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriger les données inexactes`)
};

const it_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correggere dati inesatti`)
};

const pt_br2_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir dados imprecisos`)
};

const pt_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir dados incorretos`)
};

const ja_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正確なデータの修正`)
};

const zh_privacy_right_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更正不准确的数据`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_right_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_right_2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_right_2", locale)
	if (locale === "en") return en_privacy_right_2(inputs)
	if (locale === "es") return es_privacy_right_2(inputs)
	if (locale === "de") return de_privacy_right_2(inputs)
	if (locale === "nl") return nl_privacy_right_2(inputs)
	if (locale === "fr") return fr_privacy_right_2(inputs)
	if (locale === "it") return it_privacy_right_2(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_right_2(inputs)
	if (locale === "pt") return pt_privacy_right_2(inputs)
	if (locale === "ja") return ja_privacy_right_2(inputs)
	return zh_privacy_right_2(inputs)
};